require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-standard-pick-up.json") })
        }
      }, "path---es-fleet-standard-pick-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-standard-pick-up!./.cache/json/es-fleet-standard-pick-up.json
// module id = 1091
// module chunks = 231608221292675